import { useEffect, useState } from "react";
import { MaskLines } from "../components/Reveal";
import TrackUploader from "../components/TrackUploader";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import useSeo from "../lib/useSeo";

export default function Admin() {
  useSeo("Admin", "Admin");
  const { user, loading, login } = useAuth();
  const [subs, setSubs] = useState(null);

  useEffect(() => {
    if (!user?.is_admin) return;
    api.get("/admin/subscribers").then((r) => setSubs(Array.isArray(r.data) ? r.data : [])).catch(() => setSubs([]));
  }, [user]);

  if (loading) return <div className="min-h-screen" />;
  if (!user || !user.is_admin) {
    return (
      <section className="px-5 sm:px-8 lg:px-12 pt-40 pb-32 min-h-[70vh]" data-testid="admin-locked">
        <h1 className="f-display font-black uppercase text-6xl sm:text-8xl leading-[0.85]">Restricted.</h1>
        <p className="f-serif italic text-2xl mt-6 text-[#cfcec8]">{user ? "This account does not have admin access." : "Sign in with an admin Google account."}</p>
        {!user && <button onClick={login} className="mt-10 f-mono text-xs uppercase tracking-[0.2em] border border-[var(--bone)] px-6 py-3 hover:bg-[var(--bone)] hover:text-[var(--ink)] transition-colors" data-testid="admin-login-button">Sign in with Google</button>}
      </section>
    );
  }

  return (
    <section className="px-5 sm:px-8 lg:px-12 pt-32 pb-24" data-testid="admin-page">
      <p className="eyebrow mb-5">Admin &middot; {user.email}</p>
      <h1 className="f-display font-black uppercase text-[16vw] sm:text-[10vw] lg:text-[7vw] leading-[0.84]"><MaskLines onMount lines={["Subscribers"]} /></h1>
      <p className="f-mono text-sm text-[var(--ash)] mt-6" data-testid="admin-subscriber-count">{subs ? `${subs.length} on the list` : "Loading\u2026"}</p>
      <table className="w-full mt-10 border-t border-[var(--bone)] text-left" data-testid="admin-subscriber-table">
        <thead><tr className="f-mono text-[11px] uppercase text-[var(--ash)]"><th className="py-3 font-normal">Email</th><th className="py-3 font-normal hidden sm:table-cell">Joined</th><th className="py-3 font-normal text-right">Welcome</th></tr></thead>
        <tbody>
          {(subs || []).map((s) => (
            <tr key={s.email} className="border-t border-[var(--line)]">
              <td className="py-4 f-serif text-lg break-all">{s.email}</td>
              <td className="py-4 f-mono text-xs text-[var(--ash)] hidden sm:table-cell">{(s.created_at || "").slice(0, 10)}</td>
              <td className="py-4 f-mono text-xs text-right">{s.welcomed ? "sent" : "\u2014"}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <TrackUploader />
    </section>
  );
}
